/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import "react-datepicker/dist/react-datepicker.css";

//Import PageHeader
import PageHeader from "../../components/PageHeader";

import { useHistory } from "react-router";
// Redux Store
import queryString from "query-string";
import { shallowEqual, useSelector } from "react-redux";
import CareCompanies from "../../components/CareCompany/CareCompanies";
import PartnerRequestCompanies from "../../components/Partner/PartnerRequestCompanies";
import { isManagerCompany } from "../../utils/auth";
import TaxContacts from "../../components/CareCompany/TaxContracts";

const ManagingCompanies = () => {
  const history = useHistory();
  const [activeTab, setActiveTab] = useState();
  const { user } = useSelector(
    (store) => ({
      user: store.Profile.user,
    }),
    shallowEqual
  );
  const _setActiveTab = (value) => {
    history.push({
      search: `?tab=${value}`,
    });
    setActiveTab(value);
  };


  const tabList = [
    {
      label: "내가 관리중인 기업",
      action: _setActiveTab,
      value: "companies",
    },
    {
      label: (
        <>
          요청 기업 <small className="color-red-100 font-size-10">new</small>
        </>
      ),
      action: _setActiveTab,
      value: "partner-request-companies",
    },
  ];

  useEffect(() => {
    const query = queryString.parse(history.location.search);
    const tab = query.tab;
    setActiveTab(tab || tabList[0].value);
  }, [history.location]);

  return (
    <>
      <PageHeader
        title={
          activeTab === "companies" ?
            `안녕하세요, ${user && user.name}님께서 관리중인 기업입니다. ` :
            `안녕하세요, 등록 요청한 기업입니다. `
        }
      // activeTab={activeTab}
      // tabList={tabList}
      // buttons={headerButtons}
      />
      {activeTab === "companies" && isManagerCompany() && <TaxContacts />}
      {activeTab === "companies" && (<CareCompanies />)}
      {activeTab === "partner-request-companies" && (<PartnerRequestCompanies />)}
    </>
  );
};

export default ManagingCompanies;
